import callCmAPI from 'services/helpers/call-cm-api'
import { DeleteBannerSuccessT, SuccessResponseT } from 'types/global'

/**
 * Soft-deletes a banner — the CMAPI stamps `deleted_at` rather than
 * dropping the row so we keep an audit trail. The list endpoint
 * filters deleted rows out automatically.
 *
 * Returns the 200 envelope on success. 404 (already deleted /
 * never existed) and 5xx bubble up via axios as the mutation hook's
 * `onError`. Unlike customer-group delete, there's no 409 path —
 * banners aren't referenced by any other row.
 */
export const deleteBanner = async (
  id: string,
): Promise<SuccessResponseT<DeleteBannerSuccessT>> => {
  const res = await callCmAPI(`/banner/${id}`, {
    method: 'delete',
  })
  return res.data as SuccessResponseT<DeleteBannerSuccessT>
}
